import { mt } from 'date-fns/locale';
import { laptopRatio, mobileRatio, tabletRatio, theme } from '../theme';
import { getResponsiveSize } from '../utils';

export const dashboardStyle = {
  dashboard: {
    '& .quick-access-title': {
      color: theme.palette.neutral.grey80,
      lineHeight: getResponsiveSize(27), // 27px
      py: getResponsiveSize(12), // 12px
      ...theme.palette.propVars.semiBoldFontWeight,
    },
    '& .btn-quick-access': {
      mt: getResponsiveSize(8), // 8px
      py: getResponsiveSize(12), // 12px
      px: getResponsiveSize(16), // 16px
      height: getResponsiveSize(46), // 46px
      fontSize: theme.typography.fs18, // 19px
      lineHeight: getResponsiveSize(22), // 22px
      textTransform: 'none',
      borderRadius: theme.palette.propVars.borderRadius,
      color: theme.palette.neutral.white,
      backgroundImage: `linear-gradient(to left, ${theme.palette.myPrimary.lightBlue100} 50%, ${theme.palette.myPrimary.darkBlue100} 50%)`,
      fontFamily: theme.typography.mainFontFamily,
      ...theme.palette.propVars.btnBoxShadow,
      ...theme.palette.propVars.semiBoldFontWeight,
      // slide color effect
      backgroundSize: '200%',
      backgroundPosition: ' right bottom',
      transition:
        '.45s background cubic-bezier(0.4, 0, 0.2, 1), .4s box-shadow cubic-bezier(0.4, 0, 0.2, 1)',

      '&:hover': {
        color: theme.palette.neutral.white,
        backgroundPosition: 'left bottom',
        boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.15)',
      },
      '&:active': {
        boxShadow: 'none',
      },
      '&.disabled': {
        opacity: '0.5',
        background: theme.palette.myPrimary.lightBlue100,
      },
      '& .nav-option-icon ': {
        width: getResponsiveSize(24), // 24px
        height: getResponsiveSize(24), // 24px
        fill: theme.palette.neutral.white,
        ml: getResponsiveSize(16), // 16px
        '&.treatment': {
          width: getResponsiveSize(26), // 26px
          height: getResponsiveSize(21), // 21px
          '& path:nth-of-type(1)': {
            stroke: theme.palette.neutral.white,
            fill: 'transparent',
          },
        },
        '&.play': {
          transform: 'scale(1.5)',
          stroke: theme.palette.neutral.white,
          path: {
            fill: 'none',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: getResponsiveSize(24), // 24px,
          },
        },
        '&.remote-view': {
          height: getResponsiveSize(25), // 25px
          fill: theme.palette.myPrimary.darkBlue50,
          '& path': {
            fill: theme.palette.neutral.white,
          },
        },
        // Organizations icon
        '&.organizations': {
          width: getResponsiveSize(25), // 25px
          height: getResponsiveSize(24), // 24px
        },
        // Devices icon
        '&.devices': {
          fill: 'none',
          width: getResponsiveSize(26), // 26px
          height: getResponsiveSize(24), // 24px
          '& path': {
            '&.vr-boundaries': {
              // stroke: theme.palette.myPrimary.blue,
              stroke: theme.palette.neutral.white,
              strokeWidth: '1.3px',
            },
            '&.vr-nose, &.screen': {
              // fill: theme.palette.myPrimary.blue,
              fill: theme.palette.neutral.white,
            },
          },
        },
      },
    },

    // Desktop screen
    [theme.breakpoints.media.desktop]: {
      '& .btn-quick-access': {
        fontSize: getResponsiveSize(14), // 14px
      },
    },
    // Laptop screen
    [theme.breakpoints.media.laptop]: {
      '& .quick-access-title': {
        fontSize: theme.typography.laptop.fs15,
      },
      '& .btn-quick-access': {
        height: getResponsiveSize(38, laptopRatio), // 38px
        fontSize: getResponsiveSize(15, laptopRatio), // 15px
        borderRadius: getResponsiveSize(8, laptopRatio), // 8px
        '& .nav-option-icon ': {
          '&.play': {
            transform: 'scale(2)',
            path: {
              strokeWidth: getResponsiveSize(24, laptopRatio), // 24px,
            },
          },
        },
      },
    },
    // Tablet XL screen
    [theme.breakpoints.media.tabletXL]: {
      '& .btn-quick-access': {
        fontSize: getResponsiveSize(12, laptopRatio), // 12px
      },
    },
    // Table simple responsive screen
    [theme.breakpoints.media.tableResponsive]: {
      justifyContent: 'flex-end',
      '& .content-wrapper': {
        flexDirection: 'column',
        minHeight: 'auto !important',
        m: 0,
        '& .quick-start': {
          p: 0,
          m: 0,
          minWidth: 'auto !important',
          gap: getResponsiveSize(4, mobileRatio), // 4px
          // minWidth: getResponsiveSize(200, mobileRatio), // 240px
          '& .quick-access-title': {
            fontSize: getResponsiveSize(16, mobileRatio), // 16px
            mb: getResponsiveSize(8, mobileRatio), // 8px
            p: 0,
          },
          '& .btn-quick-access': {
            height: getResponsiveSize(34, mobileRatio), // 34px
            fontSize: getResponsiveSize(13, mobileRatio), // 13px
            borderRadius: getResponsiveSize(8, mobileRatio), // 8px
            py: getResponsiveSize(8, mobileRatio), // 8px
            px: getResponsiveSize(12, mobileRatio), // 12px
            mt: 0,
            '& .nav-option-icon ': {
              width: getResponsiveSize(18, mobileRatio), // 18px
              height: getResponsiveSize(18, mobileRatio), // 18px
              minHeight: 18,
              minWidth: 18,
              ml: getResponsiveSize(8, mobileRatio), // 8px
              '&.play': {
                ml: getResponsiveSize(16, mobileRatio), // 16px
                transform: 'scale(2)',
                path: {
                  strokeWidth: getResponsiveSize(24, mobileRatio), // 24px,
                },
              },
            },
          },
        },
        '& .data-table-wrapper': {
          p: 0,
          mt: getResponsiveSize(12, mobileRatio), // 12px
        },
      },
    },
  },

  login: {
    '&.limiter': {
      width: '100%',
      m: '0 auto',
      '& .MuiTypography-body2': {
        fontSize: getResponsiveSize(14), // 14px
        m: 0,
        lineHeight: getResponsiveSize(24), // 24px
        color: '#666666',
      },
      '& .container-login100': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '100vh',
        background: '#f2f2f2',
        '& .timeout-warning-container': {
          display: 'flex',
          flexDirection: 'column',
          width: getResponsiveSize(390), // 390px
          background: theme.palette.myPrimary.white,
          borderRadius: getResponsiveSize(10), // 10px
          overflow: 'hidden',
          py: getResponsiveSize(16), // 16px
          px: getResponsiveSize(33), // 33px
          mb: getResponsiveSize(16), // 16px
          '& .icon-wrapper': {
            display: 'flex',
            alignItems: 'center',
            '& svg': {
              fontSize: getResponsiveSize(21.3), // 21.3px
              mr: getResponsiveSize(21.3), // 21.3px
            },
          },
          '& .text-no-icon': {
            ml: getResponsiveSize(42), // 42px
          },
        },
      },
      '& .wrap-login100': {
        width: getResponsiveSize(390), // 390px
        background: theme.palette.myPrimary.white,
        borderRadius: getResponsiveSize(10), // 10px
        overflow: 'hidden',
        p: getResponsiveSize(55), // 55px
        pb: getResponsiveSize(33), // 33px
        '& .login100-form': {
          width: '100%',
          '& .login100-form-title': {
            fontSize: getResponsiveSize(30), // 30px
            color: theme.palette.neutral.black,
            lineHeight: getResponsiveSize(36), // 36px
            textAlign: 'center',
            mb: getResponsiveSize(24), // 24px
            ...theme.palette.propVars.lightFontWeight,
          },
          '& .input-container': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            my: getResponsiveSize(16), // 16px
            '& .simple-text-field': {
              '& .MuiFormLabel-root': {
                fontSize: getResponsiveSize(14), // 14px
              },
              '& .MuiInputBase-input': {
                fontSize: getResponsiveSize(14), // 14px
                height: getResponsiveSize(20), // 20px
                px: getResponsiveSize(14), // 14px
                py: getResponsiveSize(16.5), // 16.5px
              },
            },
          },
          '& .container-login100-form-btn': {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            pt: getResponsiveSize(13), // 13px
            '& .wrap-login100-form-btn': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              width: '100%',
              zIndex: '1',
              borderRadius: getResponsiveSize(8), // 8px
              overflow: 'hidden',
              m: '0 auto',
              opacity: '0.9',
              ...theme.palette.propVars.easeInOutTransition,
              '&:hover': {
                opacity: '1',
              },
              '& .login100-form-btn': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: getResponsiveSize(50), // 50px
                width: '100%',
                px: getResponsiveSize(20), // 20px
                borderRadius: getResponsiveSize(5), // 5px
                fontSize: getResponsiveSize(15), // 15px
                color: theme.palette.myPrimary.white,
                lineHeight: getResponsiveSize(36), // 36px
                background: '#2983BF',
                fontFamily: theme.typography.mainFontFamily,
              },
            },
          },
          '& .password-reset-link-container': {
            display: 'flex',
            justifyContent: 'center',
            pt: getResponsiveSize(16), // 16px
            '& button': {
              fontSize: getResponsiveSize(16), // 16px
              fontFamily: theme.typography.mainFontFamily,
            },

            '& a': {
              cursor: 'pointer',

              '&:hover': {
                color: 'unset',
                textDecoration: 'underline',
              },
            },
          },
        },
      },
      // Laptop screen
      [theme.breakpoints.media.laptop]: {
        '& .wrap-login100 .login100-form': {
          '& .input-container': {
            '& .simple-text-field': {
              '& .MuiFormLabel-root': {
                fontSize: getResponsiveSize(12, laptopRatio), // 12px
              },
              '& .MuiInputBase-input': {
                fontSize: getResponsiveSize(11, laptopRatio), // 11px
                height: getResponsiveSize(12, laptopRatio), // 12px
                px: getResponsiveSize(10, laptopRatio), // 10px
                py: getResponsiveSize(12, laptopRatio), // 12px
              },
            },
          },
        },
      },
      // Tablet screen
      [theme.breakpoints.media.tablet]: {
        '& .MuiTypography-body2': {
          fontSize: getResponsiveSize(12, tabletRatio), // 12px
          lineHeight: getResponsiveSize(16, tabletRatio), // 16px
        },
        '& .container-login100': {
          '& .timeout-warning-container': {
            width: getResponsiveSize(340, tabletRatio), // 340px
            borderRadius: getResponsiveSize(8, tabletRatio), // 8px
            py: getResponsiveSize(16, tabletRatio), // 16px
            px: getResponsiveSize(33, tabletRatio), // 33px
            mb: getResponsiveSize(16, tabletRatio), // 16px
            '& .icon-wrapper svg': {
              fontSize: getResponsiveSize(21.3, tabletRatio), // 21.3px
              mr: getResponsiveSize(21.3, tabletRatio), // 21.3px
            },
            '& .text-no-icon': {
              ml: getResponsiveSize(42, tabletRatio), // 42px
            },
          },
        },
        '& .wrap-login100': {
          width: getResponsiveSize(340, tabletRatio), // 340px
          borderRadius: getResponsiveSize(8, tabletRatio), // 8px
          px: getResponsiveSize(48, tabletRatio), // 48px
          pt: getResponsiveSize(28, tabletRatio), // 33px
          pb: getResponsiveSize(24, tabletRatio), // 33px
          '& .login100-form': {
            '& .login100-form-title': {
              fontSize: getResponsiveSize(24, tabletRatio), // 24px
              lineHeight: getResponsiveSize(28, tabletRatio), // 28px
              mb: getResponsiveSize(18, tabletRatio), // 24px
            },
            '& .input-container': {
              '& .simple-text-field': {
                '& .MuiFormLabel-root': {
                  fontSize: getResponsiveSize(16, tabletRatio), // 16px
                },
                '& .MuiInputBase-input': {
                  fontSize: getResponsiveSize(12, tabletRatio), // 12px
                  height: getResponsiveSize(16, tabletRatio), // 16px
                  px: getResponsiveSize(12, tabletRatio), // 12px
                  py: getResponsiveSize(14, tabletRatio), // 14px
                },
                '& fieldset legend span': {
                  pr: getResponsiveSize(30, tabletRatio), // 30px
                },
              },
            },
            '& .container-login100-form-btn': {
              pt: getResponsiveSize(8, tabletRatio), // 13px
              '& .wrap-login100-form-btn': {
                borderRadius: getResponsiveSize(6, tabletRatio), // 6px
                '& .login100-form-btn': {
                  height: getResponsiveSize(45, tabletRatio), // 45px
                  px: getResponsiveSize(16, tabletRatio), // 16px
                  borderRadius: getResponsiveSize(5, tabletRatio), // 5px
                  fontSize: getResponsiveSize(15, tabletRatio), // 15px
                  lineHeight: getResponsiveSize(36, tabletRatio), // 36px
                },
              },
            },
            '& .password-reset-link-container': {
              pt: getResponsiveSize(16, tabletRatio), // 16px
              '& button': {
                fontSize: getResponsiveSize(14, tabletRatio), // 14px
              },
            },
          },
        },
      },
    },
    '&.reset-password': {
      '& .password-strength-bar-container': {
        mt: getResponsiveSize(-12), // 12px
        mb: getResponsiveSize(10), // 10px
      },
    },
  },

  remoteView: {
    selectOrganization: {
      width: getResponsiveSize(240),
      // Table simple responsive screen
      [theme.breakpoints.media.tableResponsive]: {
        width: getResponsiveSize(240, mobileRatio), // 240px
        '& .MuiFormLabel-root': {
          fontSize: getResponsiveSize(13, mobileRatio), // 13px
        },
        '& legend': {
          fontSize: '10px',
        },
      },
      '& .MuiOutlinedInput-root': {
        pr: `${getResponsiveSize(84)} !important`, // 84px
      },
      popperSx: {
        '& .MuiPaper-root': {
          width: `${getResponsiveSize(440)} !important`,
        },
        hintsSx: {
          width: getResponsiveSize(440),
        },
        // Tablet screen
        [theme.breakpoints.media.tablet]: {
          '& .MuiPaper-root': {
            width: '100% !important',
          },
          hintsSx: {
            width: '100%',
          },
        },
      },
    },
  },

  accountManagement: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflowY: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    '& .form-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: getResponsiveSize(390), // 390px
      background: theme.palette.myPrimary.white,
      borderRadius: getResponsiveSize(10), // 10px
      overflow: 'hidden',
      px: getResponsiveSize(55), // 55px
      pt: getResponsiveSize(32), // 32px
      pb: getResponsiveSize(32), // 32px
      ...theme.palette.propVars.btnBoxShadow,
      '& .validate-form': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      },
      '& .form-title': {
        fontSize: getResponsiveSize(26), // 26px
        color: theme.palette.neutral.black,
        lineHeight: getResponsiveSize(36), // 36px
        mb: getResponsiveSize(16), // 16px
        textAlign: 'center',
        ...theme.palette.propVars.lightFontWeight,
      },
      '& .password-strength-bar-container': {
        width: '95%',
        mx: 'auto',
        mb: getResponsiveSize(6), // 10px
      },
      '& .input-field ': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        my: getResponsiveSize(8), // 8px
        '& .MuiFormControl-root': {
          width: '100%',
        },
        '& .MuiFormHelperText-root.Mui-error': {
          color: theme.palette.neutral.errorDark,
          mx: 0.5,
        },
        '& .MuiInputAdornment-root .edit': {
          width: getResponsiveSize(20),
          height: getResponsiveSize(20),
          minWidth: '18px',
          minHeight: '18px',
          strokeWidth: 2,
        },
      },
      '& .accept': {
        minWidth: getResponsiveSize(151.5),
        mt: getResponsiveSize(8),
        '&.loading .MuiCircularProgress-root': {
          color: theme.palette.myPrimary.white15,
          height: `${getResponsiveSize(30)} !important`,
          width: `${getResponsiveSize(30)} !important`,
        },
      },
    },
    // Laptop screen
    [theme.breakpoints.media.laptop]: {
      '& .form-wrapper': {
        width: getResponsiveSize(320, laptopRatio), // 320px
        '& .form-title': {
          mb: getResponsiveSize(16, laptopRatio), // 16px
          fontSize: getResponsiveSize(22, laptopRatio), // 22px
          lineHeight: getResponsiveSize(32, laptopRatio), // 32px
        },
        '& .input-field ': {
          my: getResponsiveSize(8, laptopRatio), // 8px
        },
        '& .accept': {
          mt: getResponsiveSize(8, laptopRatio), // 8px
        },
      },
    },
    // Table simple responsive screen
    [theme.breakpoints.media.tableResponsive]: {
      '& .form-wrapper': {
        width: getResponsiveSize(280, mobileRatio), // 280px
        '& .form-title': {
          mb: getResponsiveSize(16, mobileRatio), // 16px
          fontSize: getResponsiveSize(18, mobileRatio), // 18px
          lineHeight: getResponsiveSize(32, mobileRatio), // 32px
        },
        '& .input-field ': {
          my: getResponsiveSize(8, mobileRatio), // 8px
        },
        '& .accept': {
          height: getResponsiveSize(46, mobileRatio), // 46px
          mt: getResponsiveSize(8, mobileRatio), // 8px
          fontSize: getResponsiveSize(16, mobileRatio), // 16px
        },
      },
    },
  },
};

export const sessionDetailStyle = {
  sessionDetail: {
    overflow: 'hidden',
    overflowY: 'auto',
    height: '100%',
    '& .page-header': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: getResponsiveSize(16), // 16px
      '& .main-title': {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.myPrimary.lightBlue100,
      },
    },
    '& .session-detail-container': {
      '& .charts-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: getResponsiveSize(16), // 16px,
        mt: getResponsiveSize(8), // 8px
        mb: getResponsiveSize(16),
        p: 0,
        '& .chart': {
          display: 'flex',
          flexDirection: 'column',
          flex: '1',
          p: getResponsiveSize(16), // 16px
          pb: 0,
          background: theme.palette.myPrimary.lightGrey,
          borderRadius: getResponsiveSize(12),
          '& .chart-title': {
            color: theme.palette.myPrimary.lightBlue70,
            ...theme.palette.propVars.regularFontWeight,
            ...theme.palette.propVars.actorFamily,
            ml: 2,
          },
          '& .no-data': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            my: getResponsiveSize(7),
            '& .icon': {
              width: '100%',
              height: '60%',
              color: theme.palette.myPrimary.lightBlue40,
            },
            '& .message': {
              color: theme.palette.neutral.grey20,
            },
          },
          '&.loader': {
            background: theme.palette.myPrimary.lightBlue20,
            height: getResponsiveSize(253), // 253px
          },
        },
      },
      '& .detail-grid': {
        '& .row-detail': {
          p: getResponsiveSize(16),
          py: getResponsiveSize(8),
          background: theme.palette.myPrimary.lightGrey,
          borderRadius: getResponsiveSize(12),
          height: 'fit-content',
          gap: getResponsiveSize(6),
          '& .label': {
            color: theme.palette.myPrimary.lightBlue70,
            ...theme.palette.propVars.regularFontWeight,
            ...theme.palette.propVars.actorFamily,
          },
          '& .value': {
            color: theme.palette.neutral.greyRGBA60,
            ...theme.palette.propVars.semiBoldFontWeight,
          },
          '& .actions ': {
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            right: getResponsiveSize(12),
            top: getResponsiveSize(8),
            '& .edit-btn': {
              p: getResponsiveSize(5), // 5px
              height: getResponsiveSize(38), // 38px
              width: getResponsiveSize(38), // 38px
              minWidth: 'unset',
              borderRadius: getResponsiveSize(8), // 8px
              color: theme.palette.myPrimary.white,
              transition:
                '.45s background cubic-bezier(0.4, 0, 0.2, 1), .4s box-shadow cubic-bezier(0.4, 0, 0.2, 1)',
              '& svg': {
                width: getResponsiveSize(20), // 20px
                height: getResponsiveSize(20), // 20px
                minWidth: 18,
                minHeight: 18,
                stroke: theme.palette.myPrimary.lightBlue70,
                transition: '.45s all cubic-bezier(0.4, 0, 0.2, 1)',
                '&.edit': {
                  strokeWidth: '2',
                },
              },
              '& .MuiTouchRipple-ripple': {
                transform: 'scale(1.5)',
                width: '150% !important',
                left: '-25% !important',
                '& .MuiTouchRipple-child': {
                  backgroundColor: 'currentcolor',
                },
              },
              '&:hover': {
                backgroundColor: theme.palette.myPrimary.lightBlue100,
                color: theme.palette.myPrimary.white,
                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.15)',
                '& svg': {
                  stroke: theme.palette.myPrimary.white,
                },
              },
              '&:active': {
                boxShadow: 'none',
              },
            },
          },
        },
      },
    },
    [theme.breakpoints.media.laptop]: {
      '& .session-detail-container': {
        '& .charts-container': {
          mt: getResponsiveSize(4, laptopRatio), // 4px
          '& .chart': {
            p: 0,
            pt: getResponsiveSize(16, laptopRatio),
            '& .no-data': {
              justifyContent: 'flex-start',
              '& .MuiSvgIcon-root': {
                height: '75%',
              },
            },
          },
        },
        '& .detail-grid': {
          gridTemplateColumns:
            'repeat(auto-fill, minmax(calc(33% - 1em), max-content))',
          '& .row-detail': {
            p: getResponsiveSize(16, tabletRatio),
            py: getResponsiveSize(8, tabletRatio),
            gap: getResponsiveSize(6, tabletRatio),
            '&.session-note': {
              gridColumn: '1 / -1',
            },
          },
        },
      },
    },
    [theme.breakpoints.media.tablet]: {
      '& .session-detail-container': {
        '& .charts-container': {
          flexDirection: 'column',
          mt: 0,
          rowGap: getResponsiveSize(8, tabletRatio), // 8px
          '& .chart': {
            width: '100%',
            '&.loader': {
              minHeight: getResponsiveSize(210, tabletRatio), // 210px
            },
          },
        },
        '& .detail-grid': {
          gridTemplateColumns:
            'repeat(auto-fill, minmax(calc(50% - 1em), max-content))',
          '& .row-detail': {
            '& .actions ': {
              right: getResponsiveSize(8, tabletRatio),
              top: getResponsiveSize(4, tabletRatio),
              '& .edit-btn': {
                p: getResponsiveSize(4, tabletRatio),
                height: getResponsiveSize(28, tabletRatio),
                width: getResponsiveSize(28, tabletRatio),
                borderRadius: getResponsiveSize(8, tabletRatio),
                '& svg': {
                  width: getResponsiveSize(20, tabletRatio),
                  height: getResponsiveSize(20, tabletRatio),
                },
              },
            },
          },
        },
      },
    },
    [theme.breakpoints.media.tableResponsive]: {
      '& .session-detail-container': {
        '& .charts-container': {
          rowGap: getResponsiveSize(8, mobileRatio), // 8px
          '& .chart': {
            px: getResponsiveSize(6, mobileRatio), // 6px
            pt: getResponsiveSize(12, mobileRatio), // 12px
            pb: 0,
            pr: getResponsiveSize(8, mobileRatio),
            '&.loader': {
              minHeight: getResponsiveSize(207, mobileRatio), // 207px
            },
            '& .chart-title': {
              fontSize: getResponsiveSize(13, mobileRatio), // 13px
            },
            '& .graph-wrapper .apexcharts-tooltip .tooltip-sparkline .value': {
              fontSize: getResponsiveSize(13, mobileRatio), // 13px
            },
          },
        },
        '& .detail-grid': {
          gridGap: getResponsiveSize(8, mobileRatio),
          gridTemplateColumns: 'repeat(auto-fill, minmax(100%, max-content))',
          '& .row-detail': {
            p: getResponsiveSize(16, mobileRatio),
            py: getResponsiveSize(8, mobileRatio),
            gap: getResponsiveSize(6, mobileRatio),
            '& .actions ': {
              right: getResponsiveSize(8, mobileRatio),
              top: getResponsiveSize(4, mobileRatio),
              '& .edit-btn': {
                p: getResponsiveSize(4, mobileRatio),
                height: getResponsiveSize(24, mobileRatio),
                width: getResponsiveSize(24, mobileRatio),
                borderRadius: '6px',
              },
            },
          },
        },
      },
    },
  },
};
